<div class="wrapper-action">
  @if (standardAction()) {
    <infl-touch-action
      [action]="standardAction()"
      (actionClick)="actionClick.emit($event)"
      (longPress)="longPress.emit($event)"
    />
  }
  @if (switchAction()) {
    <infl-touch-switch-action
      [action]="switchAction()"
      (actionClick)="actionClick.emit($event)"
      (longPress)="longPress.emit($event)"
    />
  }
  @if (dropdownAction()) {
    <infl-touch-dropdown-action
      [action]="dropdownAction()"
      (actionClick)="actionClick.emit($event)"
      (longPress)="longPress.emit($event)"
    />
  }
  <ng-content></ng-content>
</div>
